import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer py-14" data-testid="footer">
      <div className="container-custom">
        <div className="grid md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <span className="text-xl font-semibold tracking-[0.15em] text-[#1A1A1A] mb-4 block">
              CONNECT
            </span>
            <p className="text-[#5A5A5A] max-w-sm leading-relaxed text-sm mb-4">
              The first screenless family health and safety band. 
              Designed for connection, built for peace of mind.
            </p>
            {/* Contact Email */}
            <a 
              href="mailto:hello@connectband.health" 
              className="inline-flex items-center gap-2 text-[#5A5A5A] hover:text-[#1A1A1A] transition-colors text-sm"
            >
              <Mail className="w-4 h-4" />
              hello@connectband.health
            </a>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-medium text-[#1A1A1A] mb-4 uppercase tracking-wider">
              Product
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/#plans" className="text-[#5A5A5A] hover:text-[#1A1A1A] transition-colors text-sm">
                Plans
              </Link>
              <Link to="/#features" className="text-[#5A5A5A] hover:text-[#1A1A1A] transition-colors text-sm">
                Features
              </Link>
              <Link to="/pet-care" className="text-[#5A5A5A] hover:text-[#1A1A1A] transition-colors text-sm">
                Pet Care
              </Link>
              <Link to="/how-it-works" className="text-[#5A5A5A] hover:text-[#1A1A1A] transition-colors text-sm">
                How It Works
              </Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-medium text-[#1A1A1A] mb-4 uppercase tracking-wider">
              Legal
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/privacy" className="text-[#5A5A5A] hover:text-[#1A1A1A] transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-[#5A5A5A] hover:text-[#1A1A1A] transition-colors text-sm">
                Terms of Service
              </Link>
              <a 
                href="mailto:hello@connectband.health" 
                className="text-[#5A5A5A] hover:text-[#1A1A1A] transition-colors text-sm"
              >
                Contact
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-black/8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#7A7A7A] text-sm">
            © 2026 Connect. All rights reserved.
          </p>
          <div className="flex gap-5">
            <span className="text-[#7A7A7A] text-sm hover:text-[#4A4A4A] cursor-pointer transition-colors">
              Instagram
            </span>
            <span className="text-[#7A7A7A] text-sm hover:text-[#4A4A4A] cursor-pointer transition-colors">
              Twitter
            </span>
            <span className="text-[#7A7A7A] text-sm hover:text-[#4A4A4A] cursor-pointer transition-colors">
              LinkedIn
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
